import queryString from "query-string";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compact } from "lodash";
import ErrorPopup from "../../../../CommonComponents/ErrorPopup/ErrorPopup";
import RecommendFlow from "../../../../CommonComponents/RecommendFlow/RecommendFlow";
import { todayDate, initiateTracking } from '../../../../utils/commonUtil';
import { getAccountData, getPrimaryAccount } from '../../../../utils/sessionUtil';
import { clearUpdateErrors, needUpdate, newGrant, updateGrant } from "./actions";
import CharitySelect from "./Component/CharitySelect/CharitySelect";
import CustomizeSpawn from "./Component/CustomizeSpawn/CustomizeSpawn";
import GrantScheduleAllocation from "./Component/GrantScheduleAllocation/GrantScheduleAllocation";
import PurposeRecognition from "./Component/PurposeRecognition/PurposeRecognition";
import { ImpactContainer } from "./style";
import { createGrantAllocInput, getGrantDateType, mapGrantType } from './utils';
import { availableBalance } from "../../../../actions/globalActions";
import { ContentProvider, Types } from "../../../../CommonComponents/ContentMessages";
import { editGrantDerivedStates } from './Selectors/EditGrantSelectors';
import EditSpawn from "./Component/ViewEditSchedules/Components/EditSpawn";
import ViewGrantDetails from "./ViewGrantDetails";

export class EditGrantPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepConfig: this.stepConfig()
    };
    this.pageTitle = "View and Edit Grant";
  }

  analyticsHandler = (dataLayerName, event, name) => {
    initiateTracking(dataLayerName, this.pageTitle, event, name);
  }

  findBalance = () => {
    this.props.getAvailableBalance({
      metaData: [
        {
          method: 'GET',
          url: `/donor-portal/api/account/${
            getPrimaryAccount().userId
            }/findBalance`
        }
      ]
    });
  }

  // Required when the user recommends a grant and immediately tries to edit it
  // In this case, balance was stale without making a fresh call
  componentWillMount() {
    this.findBalance();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.updateReq) {
      this.performUpdate(nextProps)
    }
  }

  componentWillUnmount() {
    // Clean up any existing data in store for recommend grant flow
    this.props.newGrant();
  }

  createInput = (props) => ({
    grantId: props.grantId,
    partyId: getAccountData().partyId,
    granteeOrg: {
      granteeOrgId: props.charityId,
      legalName: props.charityName,
      ein: props.charityEin,
      interestArea: props.charityInterest,
    },
    grantPurpose: {
      purposeId: props.purposeId,
      additionalComments: props.additionalComments,
      publishName: props.publishName,
      missionaryName: props.missionaryName,
      eventName: props.eventName,
      missionaryLocation: props.missionaryLocation,
      projectName: props.projectName,
      purposeCertification: props.purposeCertification ? "on" : "off",
      purposeChangedFromDp: "N",
      standardLanguage: props.standardLanguage,
      otherIndDoNotIncAcctAdv: props.includeAdvisorInfo ? "off" : "on",
    },
    grantRecognition: {
      grantRecognition: props.grantRecognition,
      thankIndividualName: props.thirdParty,
      accountName: props.accountName ? props.accountName : getPrimaryAccount().accountName,
      notifyAdditionalNames: null,
      notifyFirstName: props.notifyFirstName,
      notifyLastName: props.notifyLastName,
      inMemoryOfName: props.inMemoryOfName,
      inHonorOfName: props.inHonorOfName,
      grantNotes: null,
      type: null,
    },
    requestedDeliveryDate: props.startDate || todayDate(),
    grantAmount: props.grantAmount,
    noOfPayments: props.noOfPayments,
    amountEnteredType: (props.amountType === "entireBalance" || props.amountType === "perDollarAmount") ? "byDollars" : props.amountType,
    grantAllocation: createGrantAllocInput(props.allocations, props.amountType),
    frequency: props.frequency,
    grantType: mapGrantType(props.scheduleType),
    legalTerms: "on",
    grantRequestedDateType: getGrantDateType(props.startDate),
    allShareSpecificPool: props.allShares,
    allShareAllPool: props.allSharesAllPools,
    pendingSpawnId: props.pendingSpawnId,
    scheduleId: props.scheduleId
  });

  createPurposeInput = (props) => ({
    grantId: props.grantId,
    partyId: getAccountData().partyId,
    granteeOrg: {
      granteeOrgId: props.charityId,
      legalName: props.charityName,
      ein: props.charityEin,
      interestArea: props.charityInterest,
    },
    grantPurpose: {
      purposeId: props.purposeId,
      additionalComments: props.additionalComments,
      publishName: props.publishName,
      missionaryName: props.missionaryName,
      eventName: props.eventName,
      missionaryLocation: props.missionaryLocation,
      projectName: props.projectName,
      purposeCertification: props.purposeCertification ? "on" : "off",
      purposeChangedFromDp: "Y",
      standardLanguage: props.standardLanguage,
      otherIndDoNotIncAcctAdv: props.includeAdvisorInfo ? "off" : "on",
    },
    grantRecognition: {
      grantRecognition: props.grantRecognition,
      thankIndividualName: props.thirdParty,
      accountName: props.accountName ? props.accountName : getPrimaryAccount().accountName,
      notifyAdditionalNames: null,
      notifyFirstName: props.notifyFirstName,
      notifyLastName: props.notifyLastName,
      inMemoryOfName: props.inMemoryOfName,
      inHonorOfName: props.inHonorOfName,
      grantNotes: null,
      type: null,
    },
    requestedDeliveryDate: null,
    grantAmount: null,
    noOfPayments: null,
    amountEnteredType: null,
    grantAllocation: null,
    frequency: null,
    grantType: mapGrantType(props.scheduleType),
    legalTerms: "on",
    grantRequestedDateType: null,
    scheduleId: props.scheduleId
    });
  
  
  

  onUpdate = () => {
    this.props.needUpdate();
  }

  onUpdateCancel = () => {
    initiateTracking('cancel2', 'View and Edit Grant', '', `Cancel Edit - ${this.props.scheduleType === 'recurring' ? `Recurring Grant`:`One Time Grant`}`);
    this.props.history.goBack();
  }

  performUpdate = (props) => {
    let params;
    let state;

    const { scheduleType, scheduleId, pendingSpawnId, grantId, location } = props;
    if (scheduleType === 'recurring') {
      params = { scheduleId }
    } else {
      if (pendingSpawnId) {
        params = { spawnId: pendingSpawnId }
        state = { scheduleId }
      }
      else {
        params = { grantId }
      }
    }
    if(location.pathname === "/grants/activity/edit/purpose" && scheduleType === 'recurring'){
      this.props.updateGrant({
        accountId: getPrimaryAccount().userId,
        updatedGrant: this.createPurposeInput(props),
        updateType:"recurringGrant"
      },() => {
        // After edit of grant, the header needs to reflect latest balance
        // for that the find balance API should trigger.
        this.findBalance();
        this.props.history.push({
          pathname: '/grants/activity/view',
          search: queryString.stringify(params),
          state
        });
      });
  } else{
      this.props.updateGrant({
        accountId: getPrimaryAccount().userId,
        updatedGrant: this.createInput(props)
      },() => {
        // After edit of grant, the header needs to reflect latest balance
        // for that the find balance API should trigger.
        this.findBalance();
        this.props.history.push({
          pathname: '/grants/activity/view',
          search: queryString.stringify(params),
          state
        });
      });
    }
  }

  stepConfig = () => {
    // TODO: avoid fetching primary id from session each time, causes performance impact
    const selectedAccountId = getPrimaryAccount().userId;
    const stepDesc = {
      stepOne: "Select charity and purpose",
      stepTwo: "Select allocation and schedule"
    };
    return [{
      key: 1,
      route: '/grants/activity/edit',
      subRoutes: [{
        path: '/grants/activity/edit/purpose',
        component: () => (
          <PurposeRecognition
            {...this.props}
            accountId={selectedAccountId}
            onUpdate={this.onUpdate}
            page={'Edit Grant'}
            keyPropertyUpdate={"Cancel Edit Grant"}
            onUpdateCancel={this.onUpdateCancel}
            enableCancelPopUp
            analyticsHandler={this.analyticsHandler}
          />
        )
      }],
      mainContent: () => (
        <CharitySelect
          {...this.props}
          accountId={selectedAccountId}
          onUpdateCancel={this.onUpdateCancel}
          onUpdate={this.onUpdate}
          stepDesc={stepDesc.stepOne}
          analyticsHandler={this.analyticsHandler}
        />
      )
    }, {
      key: 2,
      route: '/grants/activity/edit/allocation-schedule',
      subRoutes: [{
        path: '/grants/activity/edit/step2A',
        component: () =>
          <ViewGrantDetails {...this.props}/>
      }],
      mainContent: () => (
        <GrantScheduleAllocation
          {...this.props}
          accountId={selectedAccountId}
          onUpdate={this.onUpdate}
          onUpdateCancel={this.onUpdateCancel}
          enableCancelPopUp
          analyticsHandler={this.analyticsHandler}
          page={'Edit Grant'}
          keyPropertyUpdate={"Cancel Edit Grant"}
          fromEdit
        />
      )
    }]
  }

  renderErrors = (beErrors) => {
    const errorArr = beErrors.map(error => { 
      if (typeof(error) === 'string') return (<p>{error}</p>);
    });
    const filteredArr = compact(errorArr);
    return filteredArr.length ? filteredArr : 
      (<p>Sorry, we were unable to update the grant</p>);
  }

  pageName = () => 
    this.props.location.pathname === "/grants/activity/edit/step2A" ? null : "Edit Grant"

   isSpawnEditPage = ()=> this.props.location.pathname === "/grants/activity/edit/step2A"
  render() {
    const {
      availableBalance,
      currentBalance,
    } = this.props;
    const breadCrumbConfig = [
      {
        routeName: 'Home',
        path: '/',
      },
      {
        routeName: 'Grants',
        path: '/grants',
      },
      {
        routeName: 'Edit a Grant',
        path: '/grants/activity/edit',
      },
    ];
    const { updateErrors, clearUpdateErrors, history } = this.props;
    const showError = updateErrors && updateErrors.length;
    const showRecommendFlow = !this.isSpawnEditPage()
    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_ALERTS, Types.PAGE_PLEASE_NOTE]} pages={["Customize Recurring Grant", "Edit Grant", "Recommend a Grant"]}>
        <ImpactContainer>
          <RecommendFlow
            accData={{
              availableBalance,
              currentBalance,
            }}
            breadcrumbRoutes={showRecommendFlow&&breadCrumbConfig}
            pageHeader={this.pageName()}
            stepConfig={this.state.stepConfig}
            showAvailableBalance={showRecommendFlow}
            showCurrentBalance = {showRecommendFlow}
            editMode
            history={history}
            featureCode="VEG"
            balanceCheck={false}
            showSummary={showRecommendFlow}
          />
          {showError ? 
            <ErrorPopup show primaryCta={clearUpdateErrors}>
              {this.renderErrors(updateErrors)}
            </ErrorPopup> : ""
          }
        </ImpactContainer>
      </ContentProvider>
    );
  }
}

const mapStateToProps = state => ({
  availableBalance: state.getIn(["globalState", "availableBalance"]),
  currentBalance: state.getIn(["globalState", "currentBalance"]),

  charityId: state.getIn(["recommendGrant", "selectedCharityId"]),
  charityName: state.getIn(["recommendGrant", "selectedCharityName"]),
  charityEin: state.getIn(["recommendGrant", "selectedCharityEin"]),
  charityInterest: state.getIn(["recommendGrant", "selectedCharityInterest"]),
  purposeId: state.getIn(["recommendGrant", "grantPurposeId"]),
  additionalComments: state.getIn(["recommendGrant", "purposeComments"]),
  missionaryName: state.getIn(["recommendGrant", "missionaryName"]),
  eventName: state.getIn(["recommendGrant", "eventName"]),
  missionaryLocation: state.getIn(["recommendGrant", "missionaryLocation"]),
  projectName: state.getIn(["recommendGrant", "projectName"]),
  purposeCertification: state.getIn(["recommendGrant", "purposeCertification"]),
  standardLanguage: state.getIn(["recommendGrant", "standardLanguage"]),
  grantRecognition: state.getIn(["recommendGrant", "grantRecognition"]),
  inHonorOfName: state.getIn(["recommendGrant", "honorOf"]),
  inMemoryOfName: state.getIn(["recommendGrant", "memoryOf"]),
  notifyFirstName: state.getIn(["recommendGrant", "notifyFirstName"]),
  notifyLastName: state.getIn(["recommendGrant", "notifyLastName"]),
  thirdParty: state.getIn(["recommendGrant", "advisorThirdPartyComment"]),
  accountName: state.getIn(["recommendGrant", "accountName"]),
  includeAdvisorInfo: state.getIn(["recommendGrant", "includeAdvisorInfo"]),
  publishName: state.getIn(["recommendGrant", "permissionToPublish"]),
  grantAmount: state.getIn(["recommendGrant", "grantAmount"]),
  startDate: state.getIn(["recommendGrant", "startDate"]),
  frequency: state.getIn(["recommendGrant", "frequency"]),
  noOfPayments: state.getIn(["recommendGrant", "noOfPayments"]),
  scheduleType: state.getIn(["recommendGrant", "scheduleType"]),
  amountType: state.getIn(["recommendGrant", "allocationType"]),
  allocations: state.getIn(["recommendGrant", "allocations"]),
  allSharesAllPools: state.getIn(["recommendGrant", "allSharesAllPools"]),
  allShares: state.getIn(["recommendGrant", "allShares"]),
  grantId: state.getIn(["recommendGrant", "grantId"]),
  scheduleId: state.getIn(["recommendGrant", "scheduleId"]),
  updateReq: state.getIn(["recommendGrant", "updateReq"]),
  updateErrors: state.getIn(["recommendGrant", "updateErrors"]),
  pendingSpawnId: state.getIn(["recommendGrant", "pendingSpawnId"]),
  scheduleStatus: state.getIn(["recommendGrant", "scheduleStatus"]),
  applicable_business_function: state.getIn(["globalState", "csr", "applicable_business_function"]),
});

export const mapDispatchToProps = dispatch => ({
  updateGrant: (payload, successFn) => dispatch(updateGrant(payload, successFn)),
  needUpdate: payload => dispatch(needUpdate(payload)),
  clearUpdateErrors: () => dispatch(clearUpdateErrors()),
  newGrant: data => dispatch(newGrant(data)),
  getAvailableBalance: data => dispatch(availableBalance(data)),
});

EditGrantPage.propTypes = {
  accountName: PropTypes.string,
  additionalComments: PropTypes.string,
  allShares: PropTypes.bool,
  allSharesAllPools: PropTypes.bool,
  allocations: PropTypes.array,
  amountType: PropTypes.string,
  applicable_business_function: PropTypes.any,
  availableBalance: PropTypes.number,
  charityEin: PropTypes.string,
  charityId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  charityInterest: PropTypes.string,
  charityName: PropTypes.string,
  clearUpdateErrors: PropTypes.func,
  currentBalance: PropTypes.number,
  eventName: PropTypes.string,
  frequency: PropTypes.string,
  getAvailableBalance: PropTypes.func,
  grantAmount: PropTypes.string,
  grantId: PropTypes.string,
  grantRecognition: PropTypes.string,
  history: PropTypes.object,
  inHonorOfName: PropTypes.string,
  inMemoryOfName: PropTypes.string,
  includeAdvisorInfo: PropTypes.bool,
  location: PropTypes.object,
  missionaryLocation: PropTypes.string,
  missionaryName: PropTypes.string,
  needUpdate: PropTypes.func,
  newGrant: PropTypes.func,
  noOfPayments: PropTypes.string,
  notifyFirstName: PropTypes.any,
  notifyLastName: PropTypes.any,
  pendingSpawnId: PropTypes.any,
  projectName: PropTypes.string,
  publishName: PropTypes.bool,
  purposeCertification: PropTypes.bool,
  purposeId: PropTypes.number,
  scheduleId: PropTypes.string,
  scheduleStatus: PropTypes.string,
  scheduleType: PropTypes.string,
  standardLanguage: PropTypes.string,
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  thirdParty: PropTypes.string,
  updateErrors: PropTypes.any,
  updateGrant: PropTypes.func,
  updateReq: PropTypes.bool
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditGrantPage)
);
